import React from 'react';
import { motion } from 'framer-motion';
export function CTASection() {
  return <section id="cta-descarga" className="py-28 relative overflow-hidden" data-id="element-28">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-dark via-dark-card to-dark bg-[#FFFFFF] pt-[0px] pb-[0px]" data-id="element-29" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-[400px] bg-gold-radial opacity-40 pointer-events-none" data-id="element-30" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto text-center bg-dark/50 backdrop-blur-md border border-gold/20 rounded-3xl p-10 md:p-16 shadow-[0_0_50px_rgba(212,175,55,0.1)] pt-[10px] pb-[10px]" data-id="element-32">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mb-6 leading-tight" data-id="element-33">
            Empieza Hoy Tu Camino a Tu{' '}
            <span className="text-gold italic" data-id="element-34">Casa Propia</span>
          </h2>

          <p className="text-muted text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-35">
            Acceso inmediato · Descarga digital · 100% en español
          </p>

          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} animate={{
          boxShadow: ['0 0 20px rgba(212,175,55,0.3)', '0 0 40px rgba(212,175,55,0.6)', '0 0 20px rgba(212,175,55,0.3)']
        }} transition={{
          boxShadow: {
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} onClick={() => {
          window.location.href = 'https://www.clicygana.com/cart/47276198527154:1';
        }} className="hover:bg-gold-hover text-dark px-12 py-5 rounded-xl transition-colors w-full sm:w-auto mb-6 bg-[#D7B532] pt-[10px] pb-[10px] pl-[3px] pr-[3px] text-[28px] font-[600]" data-id="element-36">
            Descargar Guía Ahora
          </motion.button>
          <div className="flex gap-3 mb-[15px] flex-row items-start justify-center" data-id="element-37">
            <span className="text-gray-400 line-through text-sm" data-id="element-38">$19.99</span>

            <span className="text-white text-2xl font-bold" data-id="element-39">$6.39</span>

            <span className="text-green-400 font-semibold text-lg" data-id="element-40">
              68% OFF
            </span>
          </div>
          <p className="text-sm text-white/60 font-medium pl-[24px] pr-[24px]" data-id="element-41">
            Más de 500 familias ya dieron el primer paso
          </p>
        </motion.div>
      </div>
    </section>;
}